export const buildSearchUrl = (siteUrl, params = {}) => {
    const searchParams = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
            searchParams.append(key, String(value));
        }
    });
    const queryString = searchParams.toString();
    return `${siteUrl}/search${queryString ? `?${queryString}` : ''}`;
};
